import { Button } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import styles from "../css/GadgetInstallButton.module.css";
import InstallImage from "../../../images/install.svg";

interface GadgetInstallButtonProps {
    isInstallationInProgress: boolean;
    handleInstall: React.MouseEventHandler;
    isOnline: boolean;
    installationProgress: number;
}

export const GadgetInstallButton = ({isInstallationInProgress, handleInstall, isOnline, installationProgress}: GadgetInstallButtonProps) => {
    return (
        <Button
            variant="outlined" 
            data-testid={"install-button"}
            disabled={isInstallationInProgress}
            onClick={handleInstall}
            className={(isOnline ? styles.online : styles.offline) + " " + styles.installButton}
        >
        <img 
            src={InstallImage} 
            alt="install icon"
            data-testid={"install-icon"}
            style={{
                display: isInstallationInProgress ? "none": "block"
            }}
        />
        <TailSpin
            visible={isInstallationInProgress}
            height="30"
            width="30"
            color="#fff"
            ariaLabel="tail-spin-loading"
            radius="3"
            wrapperStyle={{}}
            wrapperClass=""
        />
        {isInstallationInProgress ? `${installationProgress}%` : "Install"}
    </Button>
    )
}